import React from "react";

import { getLoadingImage } from "../constants/images";
import useProgressiveImg from "../utils/ProgressiveImg";

const ComicCard = ({item, urlPart}) => {

    
    const [src, { blur }] = useProgressiveImg(getLoadingImage(item.id), item.url);  // Hacer borrosa la imagen y cuando se cargue hacerla normal

    return (

        <a href={urlPart + `/comic/${item.id}`}>
            <img
                src={src}
                className="size-full px-2" 
                style={{
                    filter: blur ? "blur(20px)" : "none",
                    transition: blur ? "none" : "filter 0.3s ease-out"
                }}
            />
        </a>
    );
}; 

export default ComicCard;